import {useEffect, useCallback} from 'react';

export const useActions = ({setIsRegionMode, parameterSelected, effect, selected, setSelected}) => {
    const lock = useCallback((locked) => {
        selected.forEach(
            p => p.locked2D = locked
        );
        setSelected([]);
    }, [selected]);

    const mergeGroups = useCallback(() => {

        let selectedGroups = new Set();
        selected.forEach(x => selectedGroups.add(x.hasGroup));
 
        // find the group with most parameters
        let maxGroup = undefined;
        for (let group of selectedGroups) {
            if (!group) {
                continue;
            }
            if (maxGroup === undefined) {
                maxGroup = group;
            } else if (maxGroup._parameters.length < group._parameters.length) {
                maxGroup = group;
            }
        }

        effect.mergeIntoGroup(maxGroup, selected);

        // now select the new group
        setSelected([... maxGroup._parameters]);
    }, [selected, setSelected]);

    useEffect(() => {
        if (parameterSelected && effect._parameters.includes(parameterSelected)) {
            if (!selected.includes(parameterSelected)) {
                setSelected([parameterSelected]);
            }
        }
    }, [parameterSelected, setSelected, selected]);

    useEffect(() => {
        if (selected.length === 0) {
            setIsRegionMode(false);
        }
    }, [selected, setIsRegionMode]);

    const locked = selected.some(x => x.locked2D);
    const grouped = selected.some(x => x.hasGroup);

    return {mergeGroups, lock, locked, grouped};
};
